import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenMerchantsEpic$ = createListenCollectionEpic({
  collection: 'merchants',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenMerchantDetailEpic$ = createListenDocEpic({
  collection: 'merchants',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenMerchantsEpic$,
  ListenMerchantDetailEpic$
};



// WEBPACK FOOTER //
// ./src/merchants/epics.ts